import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { FaCheck, FaTimes } from "react-icons/fa";
import "./Confirm.css";

const Confirm = ({
  toggle,
  setToggle,
  title = "Confirm",
  text,
  onConfirm,
}) => {
  const close = () => setToggle(false);

  const handleConfirm = async () => {
    onConfirm();
    close();
  };

  return (
    <Modal isOpen={toggle} toggle={close} centered className="brand-modal">
      <ModalHeader toggle={close}>{title}</ModalHeader>
      <ModalBody>
        <p className="confirm__text">{text}</p>
      </ModalBody>
      <ModalFooter>
        <button className="brand-modal__btn brand-modal__btn--primary" onClick={handleConfirm}>
          <FaCheck size={12} /> Confirm
        </button>
        <button className="brand-modal__btn brand-modal__btn--cancel" onClick={close}>
          <FaTimes size={12} /> Cancel
        </button>
      </ModalFooter>
    </Modal>
  );
};

export default Confirm;

